export default __webpack_public_path__ + "static/media/toyregiment.2aac643a.png";